import { FoodDrumstickIcon } from './FoodDrumstickIcon';

/**
 * author: Michael Irigoyen
 * id 83BA130B-E603-4455-B7C6-EDE9BE1FCC7E
 * name food-drumstick
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/food-drumstick.svg
 * tags
 * - Food / Drink 
 */
export const MeatIcon = FoodDrumstickIcon;
export default MeatIcon